import { render, staticRenderFns } from "./ResponsibleStudent.vue?vue&type=template&id=05106488&scoped=true&"
import script from "./ResponsibleStudent.vue?vue&type=script&lang=js&"
export * from "./ResponsibleStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05106488",
  null
  
)

export default component.exports